import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { InfoItem } from '@/models/info-item.model';

class InfoItemsService extends BaseService {
  private url: string = '/api/info-item';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<InfoItem>> {
    const res = await this.$http.get<InfoItem>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<InfoItem[]>> {
    const res = await this.$http.get<InfoItem[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    item: Partial<InfoItem>,
  ): Promise<DataResponse<InfoItem>> {
    const res = await this.$http.post<InfoItem>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: InfoItem): Promise<DataResponse<InfoItem>> {
    const res = await this.$http.put<InfoItem>(`${this.url}/${item.id}`, item);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new InfoItemsService();
